import { FC, ReactNode, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

import PropTypes from 'prop-types';
import { Badge, Collapse, ListItem } from '@mui/material';
import Button from '@mui/material/Button';

import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { SidebarContext } from 'src/context/SidebarContext';

import Icon from '@mui/material/Icon';

const useStyles = makeStyles((theme: any) => ({
  colorIcon: {
    color: theme.colors.primary.main
  }
}));

interface SidebarMenuItemProps {
  children?: ReactNode;
  link?: string;
  icon?: any;
  badge?: string;
  open?: boolean;
  active?: boolean;
  name: string;
  isParent?: boolean;
  isModule?: boolean;
}

const SidebarMenuItem: FC<SidebarMenuItemProps> = ({
  children,
  link,
  icon,
  badge,
  open: openParent,
  active,
  isParent,
  isModule,
  name,
  ...rest
}) => {
  const classes = useStyles();
  const [menuToggle, setMenuToggle] = useState<boolean | undefined>(openParent);
  const navigate = useNavigate();
  const { toggleSidebar } = useContext(SidebarContext);

  const toggleMenu = (): void => {
    setMenuToggle(Open => !Open);
  };

  if (isParent) {
    return (
      <ListItem component="div" className="Mui-children" key={name} {...rest}>
        <Button
          className={clsx('font-medium', { 'Mui-active': menuToggle && active })}
          startIcon={icon && <Icon className={clsx(`w-12 ${active ? 'text-white' : 'text-gray-400'}`)}>{icon}</Icon>}
          endIcon={menuToggle ? <ExpandLessTwoToneIcon /> : <ExpandMoreTwoToneIcon />}
          onClick={toggleMenu}
        >
          {name}
        </Button>
        <Collapse in={menuToggle}>{children}</Collapse>
      </ListItem>
    );
  }

  function handleActiveMenu(event: React.MouseEvent) {
    event.preventDefault();
    toggleSidebar();
    navigate(link as string);
  }

  return (
    <ListItem component="div" key={name} {...rest}>
      <Button
        onClick={handleActiveMenu}
        startIcon={
          icon && (
            <Icon className={clsx(`w-12 ${active ? (isModule ? 'text-white' : classes.colorIcon) : 'text-gray-400'}`)}>
              {icon}
            </Icon>
          )
        }
        className={clsx('font-medium', active && 'Mui-active')}
      >
        {name}
        {badge && <Badge badgeContent={badge} />}
      </Button>
    </ListItem>
  );
};

SidebarMenuItem.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  link: PropTypes.string,
  icon: PropTypes.elementType,
  badge: PropTypes.string,
  open: PropTypes.bool,
  name: PropTypes.string.isRequired
};

SidebarMenuItem.defaultProps = {
  open: false,
  active: false
};

export default SidebarMenuItem;
